import { render, staticRenderFns } from "./supply-edit.vue?vue&type=template&id=b012b778&scoped=true&"
import script from "./supply-edit.vue?vue&type=script&lang=js&"
export * from "./supply-edit.vue?vue&type=script&lang=js&"
import style0 from "./supply-edit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./supply-edit.vue?vue&type=style&index=1&id=b012b778&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b012b778",
  null
  
)

export default component.exports